export default "__VITE_ASSET__8258cc97__"